module.exports = __webpack_public_path__ + "static/img/chuzhongyingyu.2c4a5af9.jpg";